import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';
  if (!date || date === 'None' || date === 'null') return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  try {
    return format(d, fm);
  } catch (err) {
    return '';
  }
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';
  if (!date || date === 'None' || date === 'null') return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  try {
    return format(d, fm);
  } catch (err) {
    return '';
  }
}

export function fTimestamp(date) {
  if (!date || date === 'None' || date === 'null') return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return getTime(d);
}

export function fToNow(date) {
  if (!date || date === 'None' || date === 'null') return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  try {
    return formatDistanceToNow(d, {
      addSuffix: true,
    });
  } catch (err) {
    return '';
  }
}
